import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/harlingen")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Harlingen, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Harlingen & Cameron County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Harlingen, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Harlingen and Cameron County.",
      keywords: "awnings Harlingen, awning company Harlingen, custom awnings Harlingen, sail shades Harlingen, patio covers Harlingen, pergola covers Harlingen, metal awnings Harlingen, canvas awnings Harlingen, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Harlingen", "Cameron County"),
  }),
  component: () => <CityHomePage city="Harlingen" region="Cameron County" />,
});
